var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-slots"},[(_vm.module.slots != null)?_c('SlotMaker',{key:_vm.module._fullpath,attrs:{"creative":_vm.creative,"slots":_vm.module.slots,"parent":_vm.parent,"parent_slot":_vm.parent_slot}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }